// extracted by mini-css-extract-plugin
module.exports = {"logoGrid":"LogoGrid_logoGrid__kBzzv","sizeDefault":"LogoGrid_sizeDefault__LB3je","logo":"LogoGrid_logo__hPO4t","sizeLarge":"LogoGrid_sizeLarge__nLchv"};